@if (page(); as content) {
  <main class="explore-page">
    <nav class="breadcrumbs" aria-label="Breadcrumbs">
      <a routerLink="/">Home</a><span>/</span><span>Explore</span><span>/</span
      ><span>{{ content.title }}</span>
    </nav>
    <section class="explore-hero">
      <div>
        <p class="eyebrow">{{ content.eyebrow }}</p>
        <h1>{{ content.title }}</h1>
        <p class="explore-lede">{{ content.description }}</p>
        <a class="primary-button" routerLink="/chat">Start chatting </a>
      </div>
      <div class="explore-hero-art">
        <span>{{ appName | uppercase }}</span
        ><strong>One good<br />conversation<br />starts here.</strong
        ><i aria-hidden="true"></i>
      </div>
    </section>
    <section class="explore-intro">
      <p class="eyebrow">A MORE HUMAN INTERNET</p>
      <h2>{{ content.introTitle }}</h2>
      <p>{{ content.intro }}</p>
    </section>
    <section class="explore-points" aria-label="Page highlights">
      @for (point of content.points; track point.title) {
        <article>
          <span>0{{ $index + 1 }}</span>
          <h2>{{ point.title }}</h2>
          <p>{{ point.text }}</p>
        </article>
      }
    </section>
    <section class="explore-cta">
      <div>
        <p class="eyebrow">YOUR NEXT CONVERSATION</p>
        <h2>Meet someone new, at your pace.</h2>
        <p>Free anonymous text chat for adults worldwide.</p>
      </div>
      <a class="primary-button" routerLink="/chat">Open {{ appName }} </a>
    </section>
    <nav class="explore-related" aria-label="Related pages">
      <strong>Continue exploring</strong>
      @for (link of content.related; track link.url) {
        <a [routerLink]="link.url">{{ link.label }} </a>
      }
    </nav>
  </main>
}
